module.exports = __webpack_public_path__ + "ebbc61cb3ec520a1b9a4d7a97927891c.png";